import { render, staticRenderFns } from "./skuDetails.vue?vue&type=template&id=09d396b5&scoped=true&"
import script from "./skuDetails.vue?vue&type=script&lang=js&"
export * from "./skuDetails.vue?vue&type=script&lang=js&"
import style0 from "./skuDetails.vue?vue&type=style&index=0&id=09d396b5&scoped=true&lang=css&"
import style1 from "./skuDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d396b5",
  null
  
)

export default component.exports